import { BaseService } from '../../../../../core/services/base.service';
import { TechnicalSkills } from '../models/job.model';

export class JobSkillsService {
  static async Get(params?: {
    page?: number;
    size?: number;
    sort?: string;
    filter?: string;
  },
  options?: RequestInit
): Promise<{ content: TechnicalSkills[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : '';

    return await BaseService.Get(`/technical-skills${query}`, options, undefined, false);
  }

  static async Post(technicalSkill: TechnicalSkills): Promise<TechnicalSkills> {
    return await BaseService.Post('/technical-skills', {
      name: technicalSkill.name,
    });
  }
}
